import type {
  AnalyticsProperties,
  BookingPanelCreative,
  BookingPanelOptionAdvert,
} from '@web-platform/shared-universal-types/src/redux/state/shared/flightBookingPanel/entities/advertsBookingPanel';

export function transformARSCreativeToBookingPanelAdvert(
  creative: BookingPanelCreative,
): BookingPanelOptionAdvert {
  const {
    fields,
    id_campaign,
    id_creative,
    id_format,
    id_placement,
    id_tracking,
    performanceEventsPayloads,
    pixels,
    priority,
  } = creative;

  const analyticsPropertiesValue: AnalyticsProperties = {
    idCampaign: id_campaign,
    idCreative: id_creative,
    idPlacement: id_placement,
    idFormat: id_format,
    idTracking: id_tracking,
    priority,
  };
  const {
    customPartnerAttribute1,
    customPartnerAttribute2,
    customPartnerAttribute3,
    customPartnerAttribute4,
  } = fields;

  const attributes: string[] = [
    customPartnerAttribute1,
    customPartnerAttribute2,
    customPartnerAttribute3,
    customPartnerAttribute4,
  ].filter(Boolean);

  return {
    creative: {
      partnerId: fields.partner,
      partnerLogoUrl: fields.partnerLogo,
      brandColour: fields.brandedWrapperColour,
      textColour: fields.wrapperTextColour,
      attributes,
      dimensions: fields.dimensions,
      requestedDepth: fields.requestedDepth,
      pioPartnerName: fields.pioPartnerName,
      pioAgencyName: fields.pioAgencyName,
    },
    analyticsProperties: analyticsPropertiesValue,
    performanceEventsPayloads,
    pixels,
  };
}
